// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'subcontratos.page.title': 'Subcontratos',
    'subcontratos.page.search': 'Buscar subcontratos...',
    'subcontratos.page.filter.vigentes': 'Vigentes',
    'subcontratos.page.filter.encerrados': 'Encerrados',
    'subcontratos.page.filter.cancelados': 'Cancelados',
    'subcontratos.page.filter.todos': 'Todos',
    'subcontratos.page.col.subcontrato': 'Subcontrato',
    'subcontratos.page.col.fazenda': 'Fazenda',
    'subcontratos.page.col.cliente': 'Cliente',
    'subcontratos.page.col.rota': 'Rota',
    'subcontratos.page.col.lavoura': 'Lavoura',
    'subcontratos.page.col.peso': 'Peso',
    'subcontratos.page.col.pesoEstimado': 'Estimado {{valor}}',
    'subcontratos.page.col.dupla': 'Dupla',
    'subcontratos.page.col.origem': 'Origem',
    'subcontratos.page.col.situacao': 'Situação',
    'subcontratos.page.semStatus': 'Sem situação',
    'subcontratos.page.semDupla': 'Sem dupla',
    'subcontratos.page.empty': 'Nenhum subcontrato neste recorte.',
    'subcontratos.page.emptySearch': 'Nenhum subcontrato para "{{query}}".',
    'subcontratos.page.resumo.sincronizacao': 'Última sincronização',
    'subcontratos.page.resumo.total': 'Total',
    'subcontratos.page.resumo.vigentes': 'Vigentes',
    'subcontratos.page.resumo.semSincronizacao': 'Ainda não sincronizado',
    'subcontratos.page.detalhe.eyebrow': 'Subcontrato do Protheus',
    'subcontratos.page.detalhe.contrato': 'Contrato',
    'subcontratos.page.detalhe.descricao': 'Descrição',
    'subcontratos.page.detalhe.devedor': 'Devedor',
    'subcontratos.page.detalhe.devedorHint': 'É o Cliente nos painéis',
    'subcontratos.page.detalhe.remetente': 'Remetente',
    'subcontratos.page.detalhe.destinatario': 'Destinatário',
    'subcontratos.page.detalhe.munRemetente': 'Município do remetente',
    'subcontratos.page.detalhe.munDestinatario': 'Município do destinatário',
    'subcontratos.page.detalhe.tipoDocumento': 'Tipo de documento',
    'subcontratos.page.detalhe.safra': 'Safra',
    'subcontratos.page.detalhe.ano': 'Ano',
    'subcontratos.page.detalhe.campo': 'Campo',
    'subcontratos.page.detalhe.codigoDupla': 'Código da dupla',
    'subcontratos.page.detalhe.pesoEstimado': 'Peso estimado',
    'subcontratos.page.detalhe.pesoExecutado': 'Peso executado',
    'subcontratos.page.detalhe.pesoCobranca': 'Peso de cobrança',
    'subcontratos.page.detalhe.viagens': 'Viagens',
    'subcontratos.page.detalhe.regimeEspecial': 'Regime especial',
    'subcontratos.page.detalhe.filialOrigem': 'Filial de origem',
    'subcontratos.page.detalhe.pedagio': 'Pedágio',
    'subcontratos.page.detalhe.latitude': 'Latitude',
    'subcontratos.page.detalhe.longitude': 'Longitude',
    'subcontratos.page.detalhe.coordenadaIlegivel': 'Texto do ERP que o Hub não conseguiu ler',
    'subcontratos.page.detalhe.servicos': 'Serviços contratados',
    'subcontratos.page.detalhe.servicosVazio': 'A origem não informou serviço',
    'subcontratos.page.detalhe.distancia': 'Distância {{valor}} km',
    'subcontratos.page.sim': 'Sim',
    'subcontratos.page.nao': 'Não',
    'subcontratos.page.detalhe.sincronizadoEm': 'Sincronizado em',
    'subcontratos.page.detalhe.fechar': 'Fechar',
  },
  en: {
    'subcontratos.page.title': 'Subcontracts',
    'subcontratos.page.search': 'Search subcontracts...',
    'subcontratos.page.filter.vigentes': 'Active',
    'subcontratos.page.filter.encerrados': 'Closed',
    'subcontratos.page.filter.cancelados': 'Cancelled',
    'subcontratos.page.filter.todos': 'All',
    'subcontratos.page.col.subcontrato': 'Subcontract',
    'subcontratos.page.col.fazenda': 'Farm',
    'subcontratos.page.col.cliente': 'Customer',
    'subcontratos.page.col.rota': 'Route',
    'subcontratos.page.col.lavoura': 'Field',
    'subcontratos.page.col.peso': 'Weight',
    'subcontratos.page.col.pesoEstimado': 'Estimated {{valor}}',
    'subcontratos.page.col.dupla': 'Pair',
    'subcontratos.page.col.origem': 'Origin',
    'subcontratos.page.col.situacao': 'Status',
    'subcontratos.page.semStatus': 'No status',
    'subcontratos.page.semDupla': 'No pair',
    'subcontratos.page.empty': 'No subcontracts in this view.',
    'subcontratos.page.emptySearch': 'No subcontracts for "{{query}}".',
    'subcontratos.page.resumo.sincronizacao': 'Last sync',
    'subcontratos.page.resumo.total': 'Total',
    'subcontratos.page.resumo.vigentes': 'Active',
    'subcontratos.page.resumo.semSincronizacao': 'Not synced yet',
    'subcontratos.page.detalhe.eyebrow': 'Protheus subcontract',
    'subcontratos.page.detalhe.contrato': 'Contract',
    'subcontratos.page.detalhe.descricao': 'Description',
    'subcontratos.page.detalhe.devedor': 'Payer',
    'subcontratos.page.detalhe.devedorHint': 'Shown as Customer on the panels',
    'subcontratos.page.detalhe.remetente': 'Shipper',
    'subcontratos.page.detalhe.destinatario': 'Consignee',
    'subcontratos.page.detalhe.munRemetente': 'Shipper city',
    'subcontratos.page.detalhe.munDestinatario': 'Consignee city',
    'subcontratos.page.detalhe.tipoDocumento': 'Document type',
    'subcontratos.page.detalhe.safra': 'Season',
    'subcontratos.page.detalhe.ano': 'Year',
    'subcontratos.page.detalhe.campo': 'Field code',
    'subcontratos.page.detalhe.codigoDupla': 'Pair code',
    'subcontratos.page.detalhe.pesoEstimado': 'Estimated weight',
    'subcontratos.page.detalhe.pesoExecutado': 'Delivered weight',
    'subcontratos.page.detalhe.pesoCobranca': 'Billed weight',
    'subcontratos.page.detalhe.viagens': 'Trips',
    'subcontratos.page.detalhe.regimeEspecial': 'Special regime',
    'subcontratos.page.detalhe.filialOrigem': 'Origin branch',
    'subcontratos.page.detalhe.pedagio': 'Toll',
    'subcontratos.page.detalhe.latitude': 'Latitude',
    'subcontratos.page.detalhe.longitude': 'Longitude',
    'subcontratos.page.detalhe.coordenadaIlegivel': 'ERP text the Hub could not read',
    'subcontratos.page.detalhe.servicos': 'Contracted services',
    'subcontratos.page.detalhe.servicosVazio': 'Source reported no service',
    'subcontratos.page.detalhe.distancia': 'Distance {{valor}} km',
    'subcontratos.page.sim': 'Yes',
    'subcontratos.page.nao': 'No',
    'subcontratos.page.detalhe.sincronizadoEm': 'Synced at',
    'subcontratos.page.detalhe.fechar': 'Close',
  },
  es: {
    'subcontratos.page.title': 'Subcontratos',
    'subcontratos.page.search': 'Buscar subcontratos...',
    'subcontratos.page.filter.vigentes': 'Vigentes',
    'subcontratos.page.filter.encerrados': 'Cerrados',
    'subcontratos.page.filter.cancelados': 'Cancelados',
    'subcontratos.page.filter.todos': 'Todos',
    'subcontratos.page.col.subcontrato': 'Subcontrato',
    'subcontratos.page.col.fazenda': 'Hacienda',
    'subcontratos.page.col.cliente': 'Cliente',
    'subcontratos.page.col.rota': 'Ruta',
    'subcontratos.page.col.lavoura': 'Parcela',
    'subcontratos.page.col.peso': 'Peso',
    'subcontratos.page.col.pesoEstimado': 'Estimado {{valor}}',
    'subcontratos.page.col.dupla': 'Pareja',
    'subcontratos.page.col.origem': 'Origen',
    'subcontratos.page.col.situacao': 'Situación',
    'subcontratos.page.semStatus': 'Sin situación',
    'subcontratos.page.semDupla': 'Sin pareja',
    'subcontratos.page.empty': 'Ningún subcontrato en este recorte.',
    'subcontratos.page.emptySearch': 'Ningún subcontrato para "{{query}}".',
    'subcontratos.page.resumo.sincronizacao': 'Última sincronización',
    'subcontratos.page.resumo.total': 'Total',
    'subcontratos.page.resumo.vigentes': 'Vigentes',
    'subcontratos.page.resumo.semSincronizacao': 'Aún no sincronizado',
    'subcontratos.page.detalhe.eyebrow': 'Subcontrato de Protheus',
    'subcontratos.page.detalhe.contrato': 'Contrato',
    'subcontratos.page.detalhe.descricao': 'Descripción',
    'subcontratos.page.detalhe.devedor': 'Deudor',
    'subcontratos.page.detalhe.devedorHint': 'Es el Cliente en los paneles',
    'subcontratos.page.detalhe.remetente': 'Remitente',
    'subcontratos.page.detalhe.destinatario': 'Destinatario',
    'subcontratos.page.detalhe.munRemetente': 'Municipio del remitente',
    'subcontratos.page.detalhe.munDestinatario': 'Municipio del destinatario',
    'subcontratos.page.detalhe.tipoDocumento': 'Tipo de documento',
    'subcontratos.page.detalhe.safra': 'Zafra',
    'subcontratos.page.detalhe.ano': 'Año',
    'subcontratos.page.detalhe.campo': 'Campo',
    'subcontratos.page.detalhe.codigoDupla': 'Código de la pareja',
    'subcontratos.page.detalhe.pesoEstimado': 'Peso estimado',
    'subcontratos.page.detalhe.pesoExecutado': 'Peso ejecutado',
    'subcontratos.page.detalhe.pesoCobranca': 'Peso de cobro',
    'subcontratos.page.detalhe.viagens': 'Viajes',
    'subcontratos.page.detalhe.regimeEspecial': 'Régimen especial',
    'subcontratos.page.detalhe.filialOrigem': 'Sucursal de origen',
    'subcontratos.page.detalhe.pedagio': 'Peaje',
    'subcontratos.page.detalhe.latitude': 'Latitud',
    'subcontratos.page.detalhe.longitude': 'Longitud',
    'subcontratos.page.detalhe.coordenadaIlegivel': 'Texto del ERP que el Hub no pudo leer',
    'subcontratos.page.detalhe.servicos': 'Servicios contratados',
    'subcontratos.page.detalhe.servicosVazio': 'El origen no informó servicio',
    'subcontratos.page.detalhe.distancia': 'Distancia {{valor}} km',
    'subcontratos.page.sim': 'Sí',
    'subcontratos.page.nao': 'No',
    'subcontratos.page.detalhe.sincronizadoEm': 'Sincronizado el',
    'subcontratos.page.detalhe.fechar': 'Cerrar',
  },
}
